import type { MembershipCard } from './types';

/** Display names of the Adyen brand codes whose plain capitalisation reads wrong. */
const BRAND_NAMES: Readonly<Record<string, string>> = {
  mc: 'Mastercard',
  mastercard: 'Mastercard',
  amex: 'American Express',
  diners: 'Diners Club',
  jcb: 'JCB',
  cup: 'UnionPay',
  unionpay: 'UnionPay',
};

const brandName = (brand: string | null): string | null => {
  const code = brand?.trim().toLowerCase() ?? '';
  if (code === '') {
    return null;
  }
  return BRAND_NAMES[code] ?? code.charAt(0).toUpperCase() + code.slice(1);
};

/**
 * The card as the member card shows it: "Visa · 4242", or "•••• 4242" without
 * a brand. `null` — the line is hidden — without the last four digits: a
 * missing card is never stated, the payment service may simply not have
 * answered.
 */
export const cardMask = (
  card: MembershipCard | null | undefined,
): string | null => {
  const last4 = card?.last4?.trim() ?? '';
  if (last4 === '') {
    return null;
  }
  const brand = brandName(card?.brand ?? null);
  return brand ? `${brand} · ${last4}` : `•••• ${last4}`;
};
